export default {
  title: 'Tilvalg',
  master_title: 'Brandtilstand - Tilvalg',
  products_creation_disabled:
    'På grund af den aktive integration med {{integration}} er oprettelse af nye produkter ikke tilladt. Hvis du skal ændre menuen, skal du foretage ændringerne i {{integration}} og synkronisere menuen.',
  labels: {
    select_all: 'Vælg alle',
  },
  buttons: {
    add_modifier: 'Tilføj tilvalg',
    delete_selected: 'Slet valgte',
    refresh: 'Opdater',
  },
  toasts: {
    failed_to_load_data: 'Data kunne ikke indlæses',
  },
};
